import { useState, useEffect } from 'react';
import axios from 'axios';
import { AlertTriangle, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MaintenanceBanner() {
  const [maintenance, setMaintenance] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        const res = await axios.get(`${API}/settings/payments-status`);
        if (res.data.maintenance_mode) {
          setMaintenance({
            enabled: true,
            message: res.data.maintenance_message || null
          });
        }
      } catch (err) {
        // Ignore errors
      }
    };
    
    checkMaintenance();
    // Check every 60 seconds
    const interval = setInterval(checkMaintenance, 60000);
    return () => clearInterval(interval);
  }, []);

  if (!maintenance?.enabled || dismissed) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-yellow-600/90 to-orange-600/90 text-white py-3 px-4 relative z-50">
      <div className="max-w-6xl mx-auto flex items-center justify-center gap-3">
        <AlertTriangle className="w-5 h-5 flex-shrink-0" />
        <p className="text-sm font-medium text-center">
          {maintenance.message || (
            <>
              <span className="font-semibold">Maintenance in progress.</span>
              {' '}To ensure the highest quality of service, our algorithms are being updated. Some features may be temporarily unavailable.
            </>
          )}
        </p>
        <button 
          onClick={() => setDismissed(true)}
          className="absolute right-4 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
